import * as React from 'react';

export function useDismissOnEscape(
  isPopoverOpen: boolean,
  closeTooltip: () => void
) {
  React.useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (isPopoverOpen && event.key === 'Escape') {
        event.stopImmediatePropagation();
        event.preventDefault();
        closeTooltip();
      }
    }

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isPopoverOpen, closeTooltip]);
}

export function useDismissOnResize(
  isPopoverOpen: boolean,
  closeTooltip: () => void
) {
  React.useEffect(() => {
    function handleResize() {
      if (isPopoverOpen) {
        closeTooltip();
      }
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isPopoverOpen, closeTooltip]);
}
